(() => {
  const prefersReduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initOne(component) {
    if (!component || component.__autoplayInit) return;
    component.__autoplayInit = true;

    const container = component.querySelector(".layered-slideshow__container");
    const tablist = component.querySelector(".layered-slideshow__tablist");
    if (!container || !tablist) return;

    const getTabs = () =>
      Array.from(tablist.querySelectorAll('[role="tab"]'));

    const isEnabled = () => component.dataset.autoplay === "true";
    const intervalMs = () => {
      const raw = Number(component.dataset.interval || 0);
      return Number.isFinite(raw) && raw >= 1000 ? raw : 5000;
    };

    let timer = null;

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    const next = () => {
      // nicht wechseln wenn dragging/inert transitions etc.
      if (container.hasAttribute("data-dragging")) return;

      const tabs = getTabs();
      if (tabs.length < 2) return;

      const activeIndex = tabs.findIndex(
        (t) => t.getAttribute("aria-selected") === "true"
      );

      const i = activeIndex >= 0 ? activeIndex : 0;
      const nextTab = tabs[(i + 1) % tabs.length];
      if (nextTab) nextTab.click();
    };

    const start = () => {
      stop();
      if (prefersReduced) return;
      if (!isEnabled()) return;

      const ms = intervalMs();
      timer = setInterval(next, ms);
    };

    // Pause on hover / focus
    container.addEventListener("mouseenter", stop);
    container.addEventListener("mouseleave", start);
    container.addEventListener("focusin", stop);
    container.addEventListener("focusout", start);

    // Pause when tab not visible
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stop();
      else start();
    });

    // Restart wenn Settings im Theme Editor “live” wechseln (data-attributes ändern)
    const mo = new MutationObserver(() => start());
    mo.observe(component, { attributes: true, attributeFilter: ["data-autoplay", "data-interval"] });

    start();
  }

  function initAll(root = document) {
    root.querySelectorAll("layered-slideshow-component").forEach(initOne);
  }

  // normal load
  document.addEventListener("DOMContentLoaded", () => initAll());

  // Theme Editor: sections re-render
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();